<app-windowlist [model]="this">
    <div class="card card-outline">
        <div class="p-0">
            <div class="row p-1">
                <div class="col-lg-5">
                    <div class="input-group input-group-sm m-1" >
                        <input type="text" name="table_search" class="form-control float-right" placeholder="Cerca..." [(ngModel)]="filter_search.value" (keyup.enter)="getItems()" [class.alert-info]="filter_search.value!=''">
                        <div class="input-group-append ">
                            <button type="submit" class="btn btn-default text-primary"  title="Avvia ricerca" (click)="getItems()"><i class="fas fa-search"></i></button>
                            <button class="btn btn-default text-danger" *ngIf="filter_search.value!=''"  title="Annulla ricerca" (click)="filter_search.value='';getItems();"><span id="searchclear" class="fas fa-times"></span></button>
                            <!-- <button class="btn btn-default"   title="Regole" data-toggle="collapse" data-target="#advancedSearchPanel"  aria-expanded="false" aria-controls="advancedSearchPanel" ><span id="searchclear" class="fas fa-sliders-h text-info"></span></button> -->
                        
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 py-1" *ngIf="mode!='modal'">
                    <button  title="Cestina" *ngIf="filter_status.value == '1'" (click)="trash()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right"><i class="far fa-trash-alt"></i></button>
                    <button  title="Elimina" *ngIf="filter_status.value == '2'" (click)="delete()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right"><i class="fas fa-trash"></i></button>
                    <button  title="Ripristina" *ngIf="filter_status.value == '2'" (click)="undo()" [disabled]="form.value.id.length == 0" class="btn btn-secondary btn-xs float-right"><i class="fas fa-undo"></i></button>
                    <button  title="Esporta" (click)="export()" class="btn btn-secondary btn-xs float-right"><i class="fas fa-file-export"></i></button>
                    <button  title="Aggiungi" (click)="openDetail()" class="btn btn-success btn-xs float-right"><i class="fas fa-plus"></i></button>
                </div>
            </div>
            <div *ngIf="!list || list.length==0" class="m-4">
                <i class="fa-2x fas fa-info text-info mr-3"></i>
                <i>Nessun promemoria trovato!</i>
            </div>
            <form [formGroup]="form" *ngIf="list && list.length>0">
                <!-- <div class=" m-4" *ngIf="list.length==0">
                    <i class="fa-2x fas fa-info text-info mr-3"></i>
                    <i>Nessun promemoria trovato!</i>
                </div> -->
                <table class="table table-nowrap table-sm table-striped m-0 text-sm">
                    <thead>
                        <tr>
                            <th>
                                <div #checkboxselectall class="icheck-primary d-inline">
                                    <input type="checkbox" title="Seleziona tutti"
                                    (change)="onChangeAll($event.target.checked)" />
                                </div>
                                <!-- ID -->
                            </th>
                            <th>Validità</th>
                            <th *ngIf="id_address==0">
                                Anagrafica
                            </th>
                            <th>
                                Descrizione
                            </th>
                            <th class="text-center">Stato</th>
                            <!-- <th>Operatore</th> -->
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    
                      <!-- elemento ripetuto -->
                      <ng-container *ngFor="let record of list">
                        <tr *ngIf="id_address==0 || record.id_address==id_address">
                            <td>
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" #checkrecord id_record="{{record.id}}" title="ID: {{record.id}}"
                                    (change)="onChange(record.id, $event.target.checked)" [checked]="checkedAll"
                                    />
                                </div>
                                <!-- {{record.id}} -->
                            </td>
                            <td>{{record.date_from | date:'dd/MM/yyyy'}} - {{record.date_to | date:'dd/MM/yyyy'}}</td>
                            <td class="text-truncate" style="max-width: 5rem" *ngIf="id_address==0">
                                <i class="fas fa-user text-gray mx-1"></i>{{record.addressname}}
                            </td>
                            <td>
                                {{record.description}}
                            </td>
                            <td class="text-center">
                                <span *ngIf="record.state==1" class="badge border border-success text-success">In corso</span>
                                <span *ngIf="record.state==2" class="badge badge-primary">Completato</span>
                                <span *ngIf="record.state==3" class="badge badge-danger">Annullato</span>
                            </td>
                            <!-- <td class="text-center">
                                <div *ngIf="record.created_by" class="rounded-circle d-flex align-items-center justify-content-center bg-purple mx-auto text-uppercase" style="height:2rem; width:2rem" title="{{record.created_by}} ">{{record.created_by}}</div>
                            </td> -->
                            <td>
                                <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right">
                                    <i class="fas fa-pencil-alt"></i></button>
                                <button type="button" *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right" (click)="selectRecord(record)">
                                    <span class="d-none d-sm-inline-block">Seleziona&ensp;</span><i class="fas fa-chevron-right"></i></button>
                                <button type="button" *ngIf="mode!='modal'"  (click)="notify(record)" title="Notifica" class="btn btn-primary btn-xs float-right">
                                    <i class="far fa-paper-plane"></i></button>                                 
                            </td>
                        </tr>
                      </ng-container>

                    </tbody>                    
                </table>
            </form>
        </div>
        <div class="card-footer clearfix py-1">
            <app-pagination [model]="this" ></app-pagination>
        </div>
    </div>
</app-windowlist>